import EventEmitter2 from 'eventemitter2'

const bus = new EventEmitter2({
  wildcard: true,
  delimiter: '.'
});

export default bus